import { render } from "./MainText.vue?vue&type=template&id=54b7c1c2"
import script from "./MainText.vue?vue&type=script&lang=js"
export * from "./MainText.vue?vue&type=script&lang=js"

import "./MainText.vue?vue&type=style&index=0&id=54b7c1c2&lang=scss"
script.render = render

export default script